import { jsx } from "react/jsx-runtime";
import { createContext, useMemo } from "react";
const LearningConfigContext = createContext(null);
const LearningConfigProvider = ({
  config,
  variant,
  quizScriptApi,
  contentApi,
  progressApi,
  children
}) => {
  const value = useMemo(() => {
    const isComponentEnabled = (type) => {
      return config.sequence.some((comp) => comp.type === type && comp.enabled);
    };
    const isComponentRequired = (type) => {
      const comp = config.sequence.find((c) => c.type === type && c.enabled);
      return (comp == null ? void 0 : comp.required) ?? false;
    };
    const getComponentOptions = (type) => {
      const comp = config.sequence.find((c) => c.type === type && c.enabled);
      return comp == null ? void 0 : comp.options;
    };
    return {
      config,
      variant,
      quizScriptApi,
      contentApi,
      progressApi,
      isComponentEnabled,
      isComponentRequired,
      getComponentOptions
    };
  }, [config, variant, quizScriptApi, contentApi, progressApi]);
  return /* @__PURE__ */ jsx(LearningConfigContext.Provider, { value, children });
};
export {
  LearningConfigContext,
  LearningConfigProvider
};
//# sourceMappingURL=LearningConfigContext.js.map
